import { createAsyncThunk } from "@reduxjs/toolkit";
import { FileHolder } from "../../../@types/fileHolder";
import axios from "axios";
import api from "../../../utils/api";
import axiosInstance from "../../../utils/axiosConfig";

export const uploadDocument = createAsyncThunk(
  "uploadDocument",
  async (fileToUpload: FileHolder[], { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`${api.baseURL}remote-rrhh-solicitudes-documentos/create`, {
        idUser: fileToUpload[0].ownerId,
        idOwner: parseInt(fileToUpload[0].userId!),
        idCategory: fileToUpload[0].id,
      });
      if (response.data.status === 409) {
        return response.data.message;
      } 
      if(response.data.status === 200) {
        if (fileToUpload.length > 0) {
          const formData = new FormData();
          formData.append("file", fileToUpload[0].file);
          const { data: dataResponse } = await axiosInstance.post(`${api.baseURL}archive`, formData);

          await axiosInstance.patch(
            `${api.baseURL}archive/upload?idArchive=${dataResponse.id}&idCompliance=${response.data.solicitudDocumento.id}&idUser=${fileToUpload[0].userId}&expirationDate=${fileToUpload[0].expirationDate != undefined ? fileToUpload[0].expirationDate : '' }`
          );
          return dataResponse;
        }
      }
    } catch (error) {
      console.error(`Ocurrio un error: ${error}`);
    }
  }
);
